import script from "./FormSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSwitch.vue?vue&type=script&setup=true&lang=js"

import "./FormSwitch.vue?vue&type=style&index=0&id=0f717edd&lang=css"

const __exports__ = script;

export default __exports__